// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2QzT-","itemTitle":"ClientEmergencyInfo_itemTitle__2mP3w","itemText":"ClientEmergencyInfo_itemText__3oFm-"};